module.exports = __webpack_public_path__ + "media/images/official/about_yamori_igaa-8cf7f664507f76c3de92b69b4c158022.png";